// extracted by mini-css-extract-plugin
module.exports = {"inline-menu":"MenuV2_inline-menu__2rOnw"};